import React, { useState } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Collapse } from 'react-collapse'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'

import * as S from './TeamCollapse.styles'

const TeamCollapse = () => {
  const [toggleGiorgi, setToggleGiorgi] = useState(false)
  const [toggleMikhail, setToggleMikhail] = useState(false)
  const [toggleTsotne, setToggleTsotne] = useState(false)
  const [toggleNini, setToggleNini] = useState(false)
  
  return (
    <>
      <S.Button onClick={() => {
        setToggleMikhail(!toggleMikhail)
        setToggleGiorgi(false)
        setToggleTsotne(false)
        setToggleNini(false)
      }}>

        <Row>
          <Col md={4}><h1>Mikhail Ninikelashvili</h1></Col>
          <Col md={7}><h1>Managing Director</h1></Col>
          <Col md={1} style={{textAlign: 'right'}}>
            <FontAwesomeIcon style={{color: '#C8D3D4'}} icon={!toggleMikhail ? faPlus : faMinus} />
          </Col>
        </Row>
      </S.Button>
      <Collapse isOpened={toggleMikhail} initialStyle={{ height: '0', overflow: 'hidden' }}>
        <S.Content>
          <Row between='md'>
            <Col md={3}>
              <S.Photo src='/images/Misha1.jpg' alt='Mikhail' />
            </Col>
            <Col md={8}>
              <S.Text>Mikhail is an experienced finance professional with more than 13 years of experience in commercial banking.</S.Text>
              <S.Text>Mikhail joined Bank of Georgia’s Corporate Banking team as an analyst in 2008, where he covered the largest corporate clients of the bank. In 2016 he moved to TBC Bank’s Corporate and Investment Banking Department as a Sector Head, at different times being in charge of oil and gas, heavy industry, transportation and telecommunications sectors.</S.Text>
              <S.Text>Since 2019 he was a Senior Investment Banker in TBC Capital, Investment Banking arm of TBC Bank, executing number of high-profile Debt Capital Market transactions both locally and internationally (in the form of Eurobond issues from Georgia).</S.Text>
              <S.Text>Since September 2021, he has been a part of the Mission Gate team.</S.Text>
              <S.Text>Mikhail holds a BBA degree from Caucasus University with major in Finance.</S.Text>
            </Col>
          </Row>
        </S.Content>
      </Collapse>

  <S.Button onClick={() => {
        setToggleTsotne(!toggleTsotne)
        setToggleGiorgi(false)
        setToggleMikhail(false)
        setToggleNini(false)
      }}>
        <Row>
          <Col md={4}><h1>Tsotne Pipia</h1></Col>
          <Col md={7}><h1>Senior Associate</h1></Col>
          <Col md={1} style={{textAlign: 'right'}}>
            <FontAwesomeIcon style={{color: '#C8D3D4'}} icon={!toggleTsotne ? faPlus : faMinus} />
          </Col>
        </Row>
      </S.Button>
      <Collapse isOpened={toggleTsotne} initialStyle={{ height: '0', overflow: 'hidden' }}>
      <S.Content>
          <Row between='md'>
            <Col md={3}>
              <S.Photo src='/images/Tsotne1.jpg' alt='Tsotne' />
            </Col>
            <Col md={8}>
              <S.Text>Tsotne Pipia is an investment professional with a background in the banking industry. Before joining Mission Gate, he worked as an associate corporate analyst at Bank of Georgia – a London Stock Exchange-listed company. There, he conducted financial analysis of the companies, evaluated their creditworthiness, and monitored their performance. Prior to Bank of Georgia, Tsotne completed an internship at the largest investment bank in Georgia - Galt & Taggart.</S.Text>
              <S.Text>Since Summer 2020, he has been part of the Mission Gate team.</S.Text>
              <S.Text>Tsotne holds a BBA degree from the Free University of Tbilisi with a major in finance and a minor in mathematics and computer science.</S.Text>
            </Col>
          </Row>
        </S.Content>
      </Collapse>
  
      <S.Button onClick={() => {
          setToggleNini(!toggleNini)
          setToggleGiorgi(false)
          setToggleMikhail(false)
          setToggleTsotne(false)
      }}>

          <Row>
          <Col md={4}><h1>Nino Otiashvili</h1></Col>
          <Col md={7}><h1>General Counsel</h1></Col>
          <Col md={1} style={{textAlign: 'right'}}>
              <FontAwesomeIcon style={{color: '#C8D3D4'}} icon={!toggleNini ? faPlus : faMinus} />
          </Col>
            </Row>
          </S.Button>
          <Collapse isOpened={toggleNini} initialStyle={{ height: '0', overflow: 'hidden' }}>
            <S.Content>
          <Row between='md'>
              <Col md={3}>
                <S.Photo src='/images/Nino.jpeg' alt='Mikhail' />
            </Col>
              <Col md={8}>
                <S.Text>Nino Otiashvili is an experienced Senior Lawyer with over 10 years of expertise in legal, compliance, and risk management.</S.Text>
                <S.Text>Since 2015, Nino has been serving as Senior Lawyer at Georgian Co-Investment Fund. Previously, she served as Legal Counsel at the Agricultural Projects Management Agency and Head of the Legal Department at the Georgian Agriculture Corporation, handling corporate governance, contract negotiations, and risk mitigation.</S.Text>
                <S.Text>Since February 2025, she has been a part of the Mission Gate team.</S.Text>
                <S.Text>Nino holds an LL.M. in Business, Corporate, and Maritime Law from Erasmus University Rotterdam, along with a Bachelor’s and Master’s in International Law and International Relations from Ivane Javakhishvili Tbilisi State University.</S.Text>
                <S.Text>Fluent in Georgian, English, and proficient in Russian, Nino is dedicated to promoting legal compliance and ensuring organizational resilience.</S.Text>
              </Col>
            </Row>
          </S.Content>
         </Collapse>
    </>
  )
}

export default TeamCollapse
